// extracted by mini-css-extract-plugin
export default {"paragraph":"paragraph-reveal_paragraph__pgG-4","word":"paragraph-reveal_word__aoiEY","shadow":"paragraph-reveal_shadow__BScKT"};